// extracted by mini-css-extract-plugin
export default {"dark":"Panel_dark__J7TpE","green":"Panel_green__LwxNr","light":"Panel_light__VMiYt","orange":"Panel_orange__k-Lgf"};